import Vue from 'vue'
import Router from 'vue-router'

import search from '../pages/search.vue'
import chooseType from '../pages/choosetype.vue'
import shopInformation from '../pages/shopInformation.vue'
import companiesIntro from '../pages/companiesIntro.vue'
import ProjectList from '../pages/projectList.vue'
import ewmApply from '../pages/ewmApply.vue'
import applyForRecord from '../pages/applyForRecord.vue'
import uploadProject from '../pages/uploadProject.vue'
import Login from '../pages/login/login.vue'
import findPassword from '../pages/login/findPassword.vue'
import register from '../pages/login/register.vue'
import editPassword from '../pages/login/editPassword.vue'
import companyProfile from '../pages/companyProfile.vue'
import index from '../pages/index.vue'
import SearchResults from '../pages/searchResults.vue'
import Cashier from '../pages/cashier.vue'
import Error from '../pages/error.vue'
import Correct from '../pages/correct.vue'
import Productdetails from '../pages/productdetails.vue'
import goodsList from '../pages/goodsList.vue'
import extension from '../pages/extension.vue'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: '羽诗智能农业溯源平台',
      component: index
    },
    {
      path: '/companyprofile',
      name: '企业介绍',
      component: companyProfile
    },
    {
      path: '/projectList',
      name: '首页',
      component: ProjectList
    },
    {
      path: '/search',
      name: '溯源码查询',
      component: search
    },
    {
      path: '/error',
      name: '操作失败',
      component: Error
    },
    {
      path: '/correct',
      name: '操作成功',
      component: Correct
    },
    {
      path: '/productdetails',
      name: '订单详情',
      component: Productdetails
    },
    {
      path: '/searchResults',
      name: '查询结果',
      component: SearchResults
    },
    {
      path: '/login',
      name: '用户登录',
      component: Login
    },
    {
      path: '/choosetype',
      name: '类别选择',
      component: chooseType
    },
    {
      path: '/shopinformation',
      name: '完善信息',
      component: shopInformation
    },
    {
      path: '/companiesintro',
      name: '企业介绍',
      component: companiesIntro
    },
    {
      path: '/ewmApply',
      name: '二维码申请',
      component: ewmApply
    },
    {
      path: '/login/register',
      name: '企业注册',
      component: register
    },
    {
      path:'/cashier',
      name:'收银台',
      component:Cashier
    },
    {
      path: '/applyforrecord',
      name: '申请记录',
      component: applyForRecord
    },
    {
      path: '/uploadproject',
      name: '溯源项目上传',
      component: uploadProject
    },
    {
      path: '/login/findpassword',
      name: '找回密码',
      component: findPassword
    },
    {
      path: '/login/editpassword',
      name: '修改密码',
      component: editPassword
    },
    {
      path: '/goodsList',
      name: '溯源商品展示',
      component: goodsList
    },
    {
      path: '/extension',
      name: '推广',
      component: extension
    }
  ]
})


router.beforeEach((to, from, next) => {
  // 修改页面title
  if (to.name) {
    document.title = to.name + '-农产品溯源中心溯源防伪查询平台'
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js